import { classNames } from '@panwds/tailwindcss';
export function calcHeaderClassName({ uppercaseHeaderColumns, lastCell, tableLayoutHeaderTitleEnabled, lastGroup, stickyLeft, stickyRight, tableLayoutEnabled }) {
    return classNames('tw-group', 'tw-box-border tw-relative tw-text-xs tw-bg-white tw-h-8 dark:tw-bg-gray-1050 dark:tw-text-gray-400 tw-px-4 tw-py-1.5', uppercaseHeaderColumns && 'tw-uppercase', lastCell && 'tw-flex-grow', 'tw-border-solid tw-border-gray-300  tw-border-b dark:tw-border-gray-950 tw-font-bold', tableLayoutHeaderTitleEnabled && 'tw-border-l-0 tw-border-r-0 tw-border-t-0', !tableLayoutHeaderTitleEnabled && 'tw-border-0', !lastGroup &&
        !lastCell &&
        !stickyLeft &&
        !stickyRight &&
        !tableLayoutHeaderTitleEnabled &&
        'group-hover:tw-border-r', !lastGroup && !lastCell && !stickyLeft && !stickyRight && !tableLayoutEnabled && 'group-hover:tw-border-r', !lastGroup &&
        !lastCell &&
        !stickyLeft &&
        !stickyRight &&
        tableLayoutHeaderTitleEnabled &&
        tableLayoutEnabled &&
        'group-hover:tw-border-r', !lastCell && tableLayoutHeaderTitleEnabled && stickyLeft && 'group-hover:tw-border-r', lastGroup && 'last:tw-border-r-0');
}
//# sourceMappingURL=header_cell.logic.js.map